import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

// Pages — to be built out in subsequent steps
import DayPage from './pages/DayPage'
import LogPage from './pages/LogPage'
import ProgressPage from './pages/ProgressPage'
import ProfilePage from './pages/ProfilePage'

// Layout with bottom nav
import Layout from './components/Layout'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<Navigate to="/day" replace />} />
          <Route path="/day" element={<DayPage />} />
          <Route path="/log" element={<LogPage />} />
          <Route path="/progress" element={<ProgressPage />} />
          <Route path="/profile" element={<ProfilePage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
